// Constants for file validation
export const ALLOWED_FILE_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];
export const MAX_FILE_SIZE = 5242880; // 5MB
export const FILE_TYPE_ERROR_MSG = 'Please upload PDF, PNG, or JPEG file';
export const FILE_SIZE_ERROR_MSG = 'File size must be less than 5MB';
export const DL_NUMBER_REQUIRED_MSG = 'Please enter driving license number';
export const AADHAR_UPLOAD_REQUIRED_MSG = 'Please upload Aadhar document';
export const UPLOAD_FAILED_MSG = 'Failed to upload';
export const FILE_UPLOAD_ERROR_LOG = 'File upload error:';
export const BULK_UPLOAD_MESSAGE_KEY = 'bulk_upload';
export const BULK_UPLOAD_PROCESS_MESSAGE_KEY = 'bulk_upload_process';
export const TEXT_COLOR_DARK = '#333';
export const FONT_SIZE_SMALL = 13;
export const BUTTON_TEXT_UPLOADING = 'Uploading...';
export const BUTTON_TEXT_BROWSE = 'Browse File';
export const BUTTON_TEXT_UPLOAD_LICENSE = 'Upload Driving License';
export const BUTTON_TEXT_UPLOAD_AADHAR = 'Upload Aadhar Document';
export const EYE_ICON_STYLE = { fontSize: 16, color: '#1890ff', cursor: 'pointer' };

// Constants for file display styling
export const FILE_DISPLAY_CONTAINER_STYLE = {
	backgroundColor: '#f5f5f5',
	borderRadius: '4px',
	border: '1px solid #d9d9d9',
};
export const FILE_ICON_STYLE = { fontSize: 20, color: '#ff4d4f' };
export const CLOSE_ICON_STYLE = { fontSize: 14, color: '#999', cursor: 'pointer' };
